import React, { useState, useImperativeHandle } from 'react';
function Radio( { label, defaultValue, gridWidth, icon , options , name , onChange , visible } , ref ) {
    const containerClass = [
        'radio-group',
        gridWidth === 'HALF' ? 'half' : 'full',
        visible === false ? 'hidden' : ''
    ].join(' ').trim();

    let initialSelected = options[0]?.value;

    if ( defaultValue != null ) {
        for ( let i = 0; i < options.length; i++ ) {
            if ( options[i].value === defaultValue ) {
                initialSelected = options[i].value;
                break;
            }
        }
    }

    const [ selected, setSelected ] = useState( initialSelected );

    useImperativeHandle( ref, () => ({
        getValue: () => selected,
        setValue: ( newVal ) => setSelected( newVal ),
    }));

    const handleSelect = ( value ) => {
        setSelected( value );
        if ( typeof onChange === 'function' ) {
            onChange( value );
        }
    };

    return (
        <div className={containerClass}>
            {label != null && (
                <label className="radio-label">
                    {icon != null && (
                        <span className="radio-icon">
                            <div dangerouslySetInnerHTML={{ __html: icon }} />
                        </span>
                    )}
                    {label}
                </label>
            )}
            <div className="radio-options">
                {options.map((option) => (
                    <label key={option.id} className={`radio-option ${selected === option.value ? 'selected' : ''}`}>
                        <input
                            type="radio"
                            name={name}
                            value={option.value}
                            checked={selected === option.value}
                            onChange={() => handleSelect(option.value)}
                        />
                        {option.icon ? (
                            <span
                                className="radio-icon-only"
                                dangerouslySetInnerHTML={{ __html: option.icon }}
                                aria-label={option.value}
                            />
                        ) : (
                            <span className="radio-text">{option.value}</span>
                        )}
                    </label>
                ))}
            </div>
        </div>
    );
}

export default React.forwardRef( Radio );